import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import color from '@deprecated-ui/_style/color';
import If from 'global/ErrorHandlers/If';
import Link from 'next/link';
import Image from 'global/Image';
import { DiscoverButton } from '../styled';

interface Props {
  isRealized?: boolean;
  isRealizedFilterActive?: boolean;
}

export const EmptyState = ({
  isRealized = false,
  isRealizedFilterActive = false,
}: Props) => (
  // @ts-expect-error
  <Flex align="center" justify="center" direction="column" m="40px">
    <>
      <If condition={!isRealizedFilterActive}>
        <Image
          src={
            isRealized
              ? '/icon/empty-state-realized.svg'
              : '/icon/empty-state-history.svg'
          }
        />
      </If>
      <If condition={isRealized && isRealizedFilterActive}>
        <Image src="/icon/empty-state-outline.svg" />
      </If>
    </>
    {/* @ts-expect-error */}
    <Text family="bold" mt="16px" mb="6px" as="h3">
      <If condition={isRealized && !isRealizedFilterActive}>
        No Realized Gain Yet
      </If>
      <If condition={!isRealized}>Your History Order is Empty</If>
    </Text>
    {/* @ts-expect-error */}
    <Text size="13px" color={color.highgray} mb="10px">
      <If condition={isRealized && !isRealizedFilterActive}>
        You haven’t made any sell transactions yet.
      </If>
      <If condition={isRealized && isRealizedFilterActive}>No results found</If>
      <If condition={!isRealized}>
        No stocks in your history order. Browse stocks and start investing.
      </If>
    </Text>
    <If condition={!isRealized}>
      <Link href="/watchlist">
        <DiscoverButton as="a">
          <Text color={color.primary} family="bold" size="12px">
            Discover Now
          </Text>
        </DiscoverButton>
      </Link>
    </If>
  </Flex>
);

export const EmptyStateInModal = () => (
  // @ts-expect-error
  <Flex align="center" justify="center" direction="column" m="40px">
    <Image src="/icon/empty-state-illustration.svg" />
    {/* @ts-expect-error */}
    <Text size="13px" color={color.highgray} mb="10px">
      Tidak ada riwayat transaksi
    </Text>
  </Flex>
);

export default EmptyState;
